<template>

    <div>

        <Toolbar style="border: 0; ">
            <template #start>
                <slot name="toolBarLeftSideLeftOfRefresh"></slot>
                <Button :loading="tableInManuallyLoadingState"
                        class="ml-2 p-button-outlined" icon="fa-solid fa-arrows-rotate"
                        iconPos="left" label="Обновить" @click="searchChange"/>
                <Button v-if="_filtersNotClear" class="ml-2 p-button-outlined p-button-warning"
                        icon="fa-solid fa-broom"
                        iconPos="left" label="Сбросить фильтры" @click="clearFilters"/>
                <!--                <Button v-if="_filtersNotClear" :loading="tableInManuallyLoadingState"
                                        class="ml-2 p-button-outlined p-button-success"
                                        icon="fa-solid fa-magnifying-glass" iconPos="left" label="Найти"
                                        @click="searchChange"/>-->
                <!--                <Button v-if="!_filtersNotClear" :loading="tableInManuallyLoadingState"
                                        class="ml-2 p-button-outlined" icon="fa-solid fa-arrows-rotate"
                                        iconPos="left" label="Обновить" @click="searchChange"/>-->

                <slot name="toolBarLeftSideRightOfRefresh"></slot>
            </template>

            <template #end>
                <slot name="toolBarRightSide"></slot>
            </template>
        </Toolbar>


        <Paginator v-if="innerTotalRowsCount > innerPaginator.limit" :first="_firstTableItem"
                   :rows="innerPaginator.limit" :totalRecords="innerTotalRowsCount"
                   style="border: 0; " @page="innerPaginatorPageChanged"/>

        <slot name="DataTable"></slot>


    </div>

</template>

<script>

import Helper from "../../utils/Helper";

export default {

    name: "XDataTable",
    emits: ['update:filters', 'needGetTableItems', 'update:paginator'],
    mixins: [Helper],
    props: {
        filters: null,
        totalRowsCount: null,
        paginator: null,
    },
    data() {
        return {
            innerPaginator: {
                page: 1,
                limit: 20,
            },
            innerFilters: {},
            tableInManuallyLoadingState: false,
            innerTotalRowsCount: 0,
        }
    },
    methods: {

        clearFilters() {

            /*let new_innerFilter = {}
            for (var variableKey in this.innerFilters) {
                if (this.innerFilters.hasOwnProperty(variableKey)) {
                    this.innerFilters[variableKey] = null;
                }
            }*/

            this.innerFilters = {}

            /*let new_query = {}

            for (var variableKey in this.$route.query) {

                if (variableKey.indexOf('tf_') !== 0)
                    new_query[variableKey] = this.$route.query[variableKey]

            }

            this.$router.push({path: this.$route.path, query: new_query})*/

            this.$emit('update:filters', this.innerFilters);
            //this.searchChange();
        },

        innerPaginatorPageChanged($event) {
            this.innerPaginator.page = $event.page + 1;
            this.$emit('update:paginator', this.innerPaginator);
            this.$emit('needGetTableItems');
        },
        searchChange() {
            this.$emit('needGetTableItems')
        }
    },
    watch: {
        filters: {
            immediate: true,
            async handler($newVal) {
                this.innerFilters = $newVal;
            }
        },
        totalRowsCount: {
            immediate: true,
            async handler($newVal) {
                this.innerTotalRowsCount = $newVal;
            }
        },
        paginator: {
            immediate: true,
            async handler($newVal) {
                this.innerPaginator = $newVal;
            }
        },

    },
    computed: {
        _filtersNotClear() {
            return this.filters ? Object.values(this.filters)?.some(item => item !== null) : null;
        },
        _firstTableItem() {
            return ((this.innerPaginator.page - 1) * this.innerPaginator.limit) + 1;
        }
    }

}
</script>

<style scoped>

</style>